import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { usePortalAuth } from '../../contexts/PortalAuthContext';
import portalCaseService from '../../services/portalCaseService';
import { Briefcase, ChevronRight } from 'lucide-react';

function PortalDashboard() {
  const { user } = usePortalAuth();
  const [cases, setCases] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function loadCases() {
      try {
        const response = await portalCaseService.getCases();
        setCases(response.data.data || []);
      } catch (err) {
        console.error('Failed to load cases:', err);
      } finally {
        setLoading(false);
      }
    }
    loadCases();
  }, []);

  const statusColors = {
    active: 'bg-green-100 text-green-800',
    closed: 'bg-gray-100 text-gray-800',
    pending: 'bg-yellow-100 text-yellow-800',
  };

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">
          Welcome, {user?.client_name}
        </h1>
        <p className="mt-1 text-gray-600">
          Here's an overview of your cases and activity.
        </p>
      </div>

      {/* Cases */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200">
        <div className="p-4 border-b border-gray-200 flex items-center gap-2">
          <Briefcase className="h-5 w-5 text-blue-600" />
          <h2 className="text-lg font-semibold text-gray-900">My Cases</h2>
        </div>

        {loading ? (
          <div className="p-6 text-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600 mx-auto"></div>
          </div>
        ) : cases.length === 0 ? (
          <div className="p-6 text-center text-gray-500">
            <p>No cases to display.</p>
          </div>
        ) : (
          <div className="divide-y divide-gray-200">
            {cases.map((c) => (
              <Link
                key={c.id}
                to={`/portal/cases/${c.id}`}
                className="flex items-center justify-between p-4 hover:bg-gray-50 transition-colors"
              >
                <div className="min-w-0">
                  <p className="text-sm font-medium text-gray-900 truncate">{c.title}</p>
                  <p className="text-xs text-gray-500 mt-0.5">
                    {c.case_number && `#${c.case_number}`}
                    {c.attorney_name && ` · ${c.attorney_name}`}
                  </p>
                </div>
                <div className="flex items-center gap-2 flex-shrink-0 ml-3">
                  <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${statusColors[c.status] || 'bg-gray-100 text-gray-800'}`}>
                    {c.status}
                  </span>
                  <ChevronRight className="h-4 w-4 text-gray-400" />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default PortalDashboard;
